"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_failed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0e9e89a4-c9ee-47ac-8531-2a708898d320",
    "data-name": "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "failed-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,176a28.17,28.17,0,0,1-19.61-8,28.27,28.27,0,0,1-33.27-19.86A27.83,27.83,0,0,1,32,142.24a28.14,28.14,0,0,1-8.53-27.92A28.26,28.26,0,0,1,24,75.58,28.27,28.27,0,0,1,43.84,42.31,28.27,28.27,0,0,1,77.68,23.42a28.26,28.26,0,0,1,38.74.56,28.27,28.27,0,0,1,33.27,19.86,28.27,28.27,0,0,1,18.89,33.84,28.26,28.26,0,0,1-.56,38.74,28.27,28.27,0,0,1-19.86,33.27,28.27,28.27,0,0,1-33.84,18.89,27.88,27.88,0,0,1-10.3,6A28.44,28.44,0,0,1,95.19,176Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.07,125.85a28.14,28.14,0,0,1-19.91,21.34,28.27,28.27,0,0,1-33.84,18.89,27.88,27.88,0,0,1-10.3,6,28.16,28.16,0,0,1-28.44-6.57,28.27,28.27,0,0,1-33.27-19.86A28.26,28.26,0,0,1,22.6,120a28.27,28.27,0,0,0,19.71,28.21A28.27,28.27,0,0,0,75.58,168,28.16,28.16,0,0,0,104,174.59a27.88,27.88,0,0,0,10.3-6,28.27,28.27,0,0,0,33.84-18.89,28.14,28.14,0,0,0,19.91-21.34,27.55,27.55,0,0,0,.59-7A28.74,28.74,0,0,1,168.07,125.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,113.92c.15.69.27,1.39.37,2.09A28.09,28.09,0,0,0,176,95.47,28.16,28.16,0,0,1,168,113.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.42,111.82A28.29,28.29,0,0,1,16,94a28.46,28.46,0,0,0,1.37,10A27.85,27.85,0,0,0,23,113.84C23.11,113.16,23.25,112.49,23.42,111.82Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,152a56,56,0,1,1,56-56A56.06,56.06,0,0,1,96,152ZM96,44a52,52,0,1,0,52,52A52.06,52.06,0,0,0,96,44Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,42a56,56,0,0,1,56,55c0-.33,0-.66,0-1A56,56,0,0,0,40,96c0,.34,0,.67,0,1A56,56,0,0,1,96,42Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,94.13l17.3-17.3a4,4,0,0,0-5.66-5.66L96.13,88.47l-17.3-17.3a4,4,0,0,0-5.66,5.66l17.3,17.3-17.3,17.29a4,4,0,0,0,5.66,5.66l17.3-17.3,17.29,17.3a4,4,0,0,0,5.66-5.66Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.47,94.13l1-1-18.3-18.3a4.1,4.1,0,0,1-1-1.83,4,4,0,0,0,1,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,74.83l-18.3,18.3,1,1,17.3-17.3a4,4,0,0,0,1-3.83A4.1,4.1,0,0,1,119.08,74.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,115.08a4,4,0,0,1-5.66,0L96.13,97.78l-17.3,17.3a4,4,0,0,1-5.66,0,4.1,4.1,0,0,1-1-1.83,4,4,0,0,0,6.69,3.83l17.3-17.3,17.29,17.3a4,4,0,0,0,6.69-3.83A4.1,4.1,0,0,1,119.08,115.08Z"
  })));
}

var _default = ic_failed;
exports.default = _default;